import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { MagnifyingGlass } from "react-loader-spinner";
import amazonpay from "../../images/amazonpay.svg";
import american from "../../images/american-express.svg";
import mastercard from "../../images/mastercard.svg";
import paypal from "../../images/paypal.svg";
import visa from "../../images/visa.svg";
import discover from "../../images/discover.svg";
import ScrollToTop from "../ScrollToTop";

const MyAccountPaymentMethod = () => {
  const navigate = useNavigate();
  const [loaderStatus, setLoaderStatus] = useState(true);
const handleLogout = () => {
  const confirmLogout = window.confirm(
    "Are you sure you want to logout?"
  );

  if (!confirmLogout) return;

  localStorage.clear();
  window.location.href = "/MyAccountSignIn";
};

  /* ======================
     AUTH CHECK
  ====================== */
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
      return;
    }

    const timer = setTimeout(() => {
      setLoaderStatus(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, [navigate]);

  /* ======================
     LOGOUT
  ====================== */
 
  return (
    <div>
      <ScrollToTop />

      <section className="py-4">
        <div className="container">
          <div className="row">

            {/* MOBILE HEADER */}
            <div className="col-12 d-md-none mb-3 d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Payment Methods</h5>
              <button
                className="btn btn-outline-secondary"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasAccount"
              >
                <i className="fas fa-bars"></i>
              </button>
            </div>

            {/* SIDEBAR */}
            <div className="col-lg-3 d-none d-md-block border-end">
              <ul className="nav flex-column nav-pills p-4 gap-2">
                <li>
                  <Link className="nav-link" to="/MyAccountOrder">
                    <i className="fas fa-shopping-bag me-2" /> Your Orders
                  </Link>
                </li>
                <li>
                  <Link className="nav-link" to="/MyAccountSetting">
                    <i className="fas fa-cog me-2" /> Settings
                  </Link>
                </li>
                <li>
                  <Link className="nav-link" to="/MyAccountAddress">
                    <i className="fas fa-map-marker-alt me-2" /> Address
                  </Link>
                </li>
                <li>
                  <Link className="nav-link active" to="/MyAccountPayment">
                    <i className="fas fa-credit-card me-2" /> Payment Method
                  </Link>
                </li>
                <hr />
                <li>
                  <button
                    className="nav-link text-danger btn btn-link text-start"
                    onClick={handleLogout}
                  >
                    <i className="fas fa-sign-out-alt me-2" /> Logout
                  </button>
                </li>
              </ul>
            </div>

            {/* MAIN CONTENT */}
            <div className="col-lg-9">
              {loaderStatus ? (
                <div className="text-center my-5">
                  <MagnifyingGlass height="80" width="80" color="#0aad0a" />
                </div>
              ) : (
                <div className="p-4">
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h3>Payment Methods</h3>
                    <button
                      className="btn btn-outline-primary"
                      data-bs-toggle="modal"
                      data-bs-target="#paymentModal"
                    >
                      Add Payment
                    </button>
                  </div>

                  <ul className="list-group list-group-flush">
                    <li className="list-group-item py-4 d-flex justify-content-between">
                      <div className="d-flex">
                        <img src={visa} alt="visa" />
                        <div className="ms-3">
                          <strong>**** 1234</strong>
                          <p className="mb-0 small text-muted">
                            Expires 10/2026
                          </p>
                        </div>
                      </div>
                      <span className="text-muted small">Default</span>
                    </li>

                    <li className="list-group-item py-4 d-flex justify-content-between">
                      <div className="d-flex">
                        <img src={mastercard} alt="mastercard" />
                        <div className="ms-3">
                          <strong>**** 5678</strong>
                          <p className="mb-0 small text-muted">
                            Expires 03/2027
                          </p>
                        </div>
                      </div>
                      <button className="btn btn-sm btn-outline-secondary" disabled>
                        Remove
                      </button>
                    </li>
                  </ul>

                  <p className="text-muted mt-3">
                    ⚠️ Payment method management will be enabled soon.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* OFFCANVAS MOBILE */}
      <div className="offcanvas offcanvas-start" id="offcanvasAccount">
        <div className="offcanvas-header">
          <h5>My Account</h5>
          <button className="btn-close" data-bs-dismiss="offcanvas" />
        </div>
        <div className="offcanvas-body">
          <ul className="nav flex-column gap-2">
            <li><Link to="/MyAccountOrder" className="nav-link">Your Orders</Link></li>
            <li><Link to="/MyAccountPayment" className="nav-link active">Payment Method</Link></li>
            <li>
          <button
  type="button"
  className="dropdown-item text-danger"
  onClick={() => {
    const ok = window.confirm("Are you sure you want to logout?");
    if (!ok) return;

    // 🔔 SHOW TOAST
    const toastEl = document.getElementById("logoutToast");
    if (toastEl && window.bootstrap) {
      const toast = new window.bootstrap.Toast(toastEl, {
        delay: 1500,
      });
      toast.show();
    }

    // ⏳ thoda delay so toast dikh jaaye
    setTimeout(() => {
      localStorage.clear();
      window.location.href = "/MyAccountSignIn";
    }, 1200);
  }}
>
  Logout
</button>


            </li>
          </ul>
        </div>
      </div>

      {/* PAYMENT MODAL (UI ONLY) */}
      <div className="modal fade" id="paymentModal">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content p-4">
            <h5>Add New Payment Method</h5>
            <p className="text-muted">
              Secure card saving will be available soon.
            </p>
            <button
              className="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyAccountPaymentMethod;
